import * as React from 'react';

import * as styles from './styles.css';

export const NewbuildingHeaderServices: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  return <div className={styles['services']}>{children}</div>;
};
